import React, { useEffect } from "react";
import { Container, Row, Col, Carousel, CarouselItem } from "react-bootstrap";
import Mission from "./Mission.jsx";
import Objective from "./Objective.jsx";
import Policy from "./Policy.jsx";
import Values from "./Values.jsx";
import Vision from "./Vision.jsx";

import Aos from "aos";
import "aos/dist/aos.css";

const items = [
  { id: 1, component: <Vision />, label: "Vision" },
  { id: 2, component: <Mission />, label: "Mission" },
  { id: 3, component: <Values />, label: "Values" },
  { id: 4, component: <Policy />, label: "Policy" },
  { id: 5, component: <Objective />, label: "Objective" },
];

function ObjectiveSection() {
  useEffect(() => {
    Aos.init({ duration: 2000, delay: 2 });
  }, {});



  return (
    <Container className="container-fluid" style={{ overflow: "hidden" }}>
      {/* Large screens */}      <Row
        xs={1}
        sm={2}
        md={5}
        className="d-none d-md-flex align-items-start justify-content-start gap-0"
      >
        {items.map(({ id, component }) => (
          <Col
            xs={12}
            key={id}
            data-aos="fade-up"
            className="d-flex align-items-start justify-content-start"
          >
            {component}
          </Col>
        ))}
      </Row>

      {/* Small screens */}
      <div
        className="d-md-none"
      >
        <Carousel indicators={false} controls={true}>
          {items.map(({ id, component, label }) => (
            <CarouselItem key={id}>{component}</CarouselItem>
          ))}
        </Carousel>
      </div>
    </Container>
  );
}

export default ObjectiveSection;
